document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".search-results-page")) {
        import(/* webpackChunkName: "search-results" */ "/Features/Search/js/search-results.js").then(async (module) => {
            const searchResultPage = new module.default();
            window.srpPaginationComplete = searchResultPage.srpPaginationComplete.bind(searchResultPage);
            await searchResultPage.init();
        });
    }
});